import React from 'react';
import {
	Select as MuiSelect,
	MenuItem,
	InputLabel,
	FormControl,
	SelectChangeEvent,
	Typography,
} from '@mui/material';
import ChevronDownIcon from "assets/icons/ChevronDown";

interface CustomSelectProps {
	label: string;
	options: { id: string; title: string }[];
	multiple?: boolean;
	setSelected: (event: SelectChangeEvent<string>) => void;
	selected: { id: string; title: string } | null;
	shouldAddMt?: boolean;
}

const Select: React.FC<CustomSelectProps> = ({label, options, multiple, selected, setSelected, shouldAddMt}) => {
	return (
		<FormControl variant="outlined" sx={{mt: shouldAddMt ? 2 : undefined}} fullWidth>
			<InputLabel shrink sx={{
				top: 8, left: 12,
				color: 'grey.200',
				textTransform: 'uppercase',
				fontSize: 10,
				fontWeight: 500,
				letterSpacing: '1px',
				lineHeight: '150%',
				fontFamily: "Pragmatica Extended, arial, sans-serif"
			}}>{label}</InputLabel>
			<MuiSelect
				fullWidth
				multiple={multiple}
				disableUnderline
				displayEmpty
				variant={'filled'}
				value={selected?.id || ''}
				onChange={setSelected}
				label={label}
				IconComponent={ChevronDownIcon}
			>
				<MenuItem value="">
					<Typography variant={'h6'} sx={{color: 'grey.500'}}>
						Не выбрано
					</Typography>
				</MenuItem>

				{options.map((option) => (
					<MenuItem key={option.id} value={option.id}
							  sx={{
								  '&.Mui-selected': {
									  color: 'blue.100'
								  }
							  }}>
						<Typography variant={'h6'}>{option.title}</Typography>
					</MenuItem>
				))}
			</MuiSelect>
		</FormControl>
	);
};

export default Select;
